module.exports = __webpack_public_path__ + "static/header-aeaa1faa60e162255e6f86e83e07aed9.png";